<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <div class="row mt-4">
        <div class="col">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">{{(isEdit) ? 'Edit' : 'Add'}} Journal Club</h3>
            </div>
            <v-stepper v-model="e1" light>
              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" step="1" editable>Journal Club Details</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step v-if="!isEdit" :complete="e1 > 2" step="2">Journal Club Media</v-stepper-step>
                <v-stepper-step v-if="isEdit" :complete="e1 > 2" step="2" @click="updateValidate" editable>Journal Club Media</v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content class="v-form-body" step="1">
                  <v-form ref="form" v-model="valid" lazy-validation enctype="multipart/form-data">
                    <v-row>
                      <v-col cols="6">
                        <label class="form-control-label">
                          Name
                          <span class="red--text">*</span>
                        </label>
                        <v-text-field
                          v-model="journalClub.name"
                          placeholder="Enter Journal Club Name"
                          :rules="[(v) => !!v || 'Title is required!']"
                          required
                          solo
                        ></v-text-field>
                      </v-col>
                      
                       <v-col cols="6">
                        <v-menu
                          ref="menu1"
                          v-model="datepickerField"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <label class="form-control-label">
                              Published Date
                              <span class="red--text">*</span>
                            </label>
                            <v-text-field
                              v-model="journalClub.publishedDate"
                              label="Published Date"
                              :rules="[(v) => !!v || 'Published Date is required!']"
                              solo
                              append-icon="mdi-calendar"
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="journalClub.publishedDate"
                            no-title
                            @change="datepickerField = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>

                      <v-col cols="12">
                        <label class="form-control-label">
                          Description
                          <span class="red--text">*</span>
                        </label>
                        <quill-editor
                          v-model="journalClub.description"
                          ref="journalClubDesc"
                          :options="editorOption"
                        ></quill-editor>
                      </v-col>

                      <v-col cols="6">
                        <v-card-title class="pt-8 pr-0 justify-start">
                          <h4>Active</h4>
                          <v-switch class="pl-4 pt-3 mt-0" v-model="journalClub.isActive" flat:label="Yes" inset></v-switch>
                        </v-card-title>
                      </v-col>

                      <v-col class="text-right" cols="12">
                        <v-btn color="#989898" class="mr-4 white--text" @click="cancel">Cancel</v-btn>
                        <v-btn
                          v-if="!isEdit"
                          :disabled="!valid"
                          :loading="loading"
                          color="#344452"
                          class="white--text"
                          @click="saveValidate"
                        >Next</v-btn>
                        <v-btn
                          v-if="isEdit"
                          :disabled="!valid"
                          :loading="loading"
                          color="#344452"
                          class="white--text"
                          @click="updateValidate"
                        >Next</v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-stepper-content>

                <v-stepper-content class="v-form-body" step="2">
                  <v-row>
                    <v-col :class="$vuetify.breakpoint.mdAndUp ? 'col-6' : 'col-12'" class="pa-5">
                      <v-card>
                        <v-card-title>
                          <span class="Subtitle 1">Upload Image</span>
                        </v-card-title>
                        <v-card-text>
                          <vue-dropzone
                            class="vue-dropzone-box"
                            ref="myVueDropzone"
                            id="dropzone"
                            :destroyDropzone="false"
                            :options="dropzoneOptions"
                            @vdropzone-sending="beforecomplete"
                            @vdropzone-success="aftercomplete"
                            @vdropzone-canceled="afterCanceled"
                            @vdropzone-mounted="uploadedImage"
                            @vdropzone-removed-file="removeFile"
                            :useCustomSlot="true"
                            :useCustomDropzoneOptions="true"
                          >
                            <div class="dropzone-custom-content">
                              <img src="@/assets/images/ImageUpload.svg" />
                              <h3 class="font-weight-light ma-0">Drag and drop here to upload</h3>
                              <h3 class="font-weight-light ma-0">Or</h3>
                              <h3 class="dropzone-custom-title">Browse</h3>
                            </div>
                          </vue-dropzone>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <!-- <v-col :class="$vuetify.breakpoint.mdAndUp ? 'col-6' : 'col-12'" class="pa-5">
                      <v-card>
                        <v-card-title>
                          <span class="Subtitle 1">Upload Banner Image</span>
                        </v-card-title>
                        <v-card-text>
                          <div class="upload-img-section">
                            <v-card flat class="pa-2">
                                <v-card-text class="text-center">
                                  <img v-if="bannerImageOption.croppedUrl === null" src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1606300207502.png" class="banner-img">
                                  <img v-if="bannerImageOption.croppedUrl !== null" :src="bannerImageOption.croppedUrl" class="banner-img">
                                </v-card-text>
                                <v-card-actions class="justify-center">
                                <v-btn @click="$refs.bannerFileInput.click()" color="#344452" class="white--text px-1"> <v-icon class="mdi mdi-image"></v-icon> Browse </v-btn>
                                <input ref="bannerFileInput" type="file" style="display: none;" @change="onFileSelect($event,bannerImageOption)"/>
                                <v-btn v-if="bannerImageOption.croppedUrl!== null" color="gray"  class="mx-2 delete-btn" @click="removeFile(bannerImageOption)" :loading="bannerImageOption.deleteLoading"><v-icon>mdi mdi-delete</v-icon> Delete</v-btn>
                                </v-card-actions>
                              </v-card>
                          </div>
                          <img-cropper
                          v-if="bannerImageOption.dialog===true"
                          :imageObject="bannerImageOption"
                          :moduleId="newsFeedId"
                          @updateMedia="updateMedia"
                          ></img-cropper>  
                        </v-card-text>
                      </v-card>
                    </v-col> -->
                    <document-upload
                      :documents="documents"
                       moduleName="education/journalClub"
                      :moduleId="journalClubId"
                      v-if="e1 == 2"
                      :maxFiles="1"
                    ></document-upload>
                  </v-row>
                  <v-col class="text-right" cols="12">
                    <v-btn color="#989898" class="mr-4 white--text" @click="cancel">Cancel</v-btn>
                    <v-btn
                      :disabled="!valid"
                      color="#344452"
                      class="white--text"
                      :loading="loading"
                      @click="save"
                    >{{(isEdit) ? 'Update' : 'Save'}}</v-btn>
                  </v-col>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import CommonSection from "@/components/CommonHeader";
import { MediaService, JournalClubService } from "@/services";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import { CLINIC_IMAGE_WIDTH, CLINIC_IMAGE_HEIGHT,BANNER_WIDTH,BANNER_HEIGHT,MEDIATYPE_BANNER } from "@/constants";
import { ImageValidateMixin } from "@/mixins";
import moment from "moment";

export default {
  name: "AddJournalClub",
  components: {
    CommonSection,
    quillEditor,
    vueDropzone: vue2Dropzone,
    documentUpload: () => import("@/components/DocumentUpload"),
    //ImgCropper: () => import("./ImgCropperModel"),
  },
  mixins: [ImageValidateMixin],
  data() {
    var self = this;
    return {
      e1: 1,
      loading: false,
      isEdit: false,
      valid: true,
      journalClubId: null,
      status: false,
      media: [],
      journalClub: {
        name: null,
        isActive: false,
        description: null,
        publishedDate: null,
      },
      datepickerField:false,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_SERVERURL}media`,
        chunking: true,
        addRemoveLinks: true,
        autoProcessQueue: true,
        maxFilesize: 2, // MB
        thumbnailWidth: 300,
        maxFiles: 1,
        headers: {
          Authorization: `Bearer ${store.state.user.token}`,
        },
        dictFileTooBig:"File is too big ({{filesize}}MB). Max filesize: {{maxFilesize}}MB.",
        acceptedFiles: "image/*",
          init() {
            this.on("thumbnail",(file) => {
              self.validateBannerDimension(file,CLINIC_IMAGE_WIDTH,CLINIC_IMAGE_HEIGHT)
            });
            this.on("addedfile", file => {
            if (file.size > 1024 * 1024 * 2) {
              // not more than 2mb
              this.removeFile(file);
            }
          });
          },
          accept(file, done) {
            self.showError(file,CLINIC_IMAGE_WIDTH,CLINIC_IMAGE_HEIGHT,done)
          }
      },
      editorOption: {
        theme: "snow",
      },
      bannerImageOption:{
        image: null,
        croppedUrl: null,
        croppedFile: null,
        loading:false,
        originalFile:null,
        width:BANNER_WIDTH,
        height:BANNER_HEIGHT,
        mediaType:MEDIATYPE_BANNER,
        dialog:false,
        deleteLoading:false
      }
    };
  },
  computed: {
     editor() {
      return this.$refs.journalClubDesc.quill;
    },
    documents() {
      if (this.media && this.media.length > 0) {
        return this.media.filter((media) => media.mediaType == "doc");
      } else {
        return [];
      }
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async getJournalClubData() {
      const journalClub = await JournalClubService.getJournalClub(this.$route.params.id);
      this.journalClub.name = journalClub.data.data[0].name;
      this.journalClub.description = journalClub.data.data[0].description;
      this.journalClub.publishedDate = moment(journalClub.data.data[0].publishedDate).format("YYYY-MM-DD");
      this.journalClub.isActive = journalClub.data.data[0].isActive;
      this.media = journalClub.data.data[0].media;
    },
    async initialize() {
      if (this.$route.params.id !== 'create') { 
        this.isEdit = true;
        await this.getJournalClubData();
        await this.uploadedImage();
      }
    },
    async saveValidate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          const response = await  JournalClubService.createJournalClub(this.journalClub);
          this.loading = false;
          if (response) {
            this.e1 = 2;
            this.journalClubId = response.data.id;
            this.$store.dispatch(
              "user/setSnack",
              "Journal Club added successfully!"
            );
            this.$store.dispatch("user/setType", "info");
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
    async updateValidate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          const response = await JournalClubService.updateJournalClub({
            id: this.$route.params.id,
            object: this.journalClub,
          });
          this.loading = false;
          if (response) {
            this.e1 = 2;
            this.journalClubId = response.data.id;
            this.$store.dispatch(
              "user/setSnack",
              "Journal Club updated successfully!"
            );
            this.$store.dispatch("user/setType", "info");
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          this.loading = false;
          this.$router.push("/journal-club");
          this.$store.dispatch("user/setSnack", `Journal Club ${(this.isEdit) ?  'updated' : 'added'} successfully!`);
          this.$store.dispatch("user/setType", "info");
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
    beforecomplete(file, xhr, formData) {
      formData.append("mediaType", "image");
      formData.append("moduleType", "education/journalClub");
      formData.append("mediaSubType", "file");
      // formData.append("imageType", MEDIATYPE_THUMBNAIL);
      formData.append("moduleId", this.journalClubId);
    },
    aftercomplete() {
      this.$store.dispatch(
        "user/setSnack",
        "Journal Club Image uploaded successfully!"
      );
      this.getJournalClubData();
      this.$store.dispatch("user/setType", "info");
    },
    afterCanceled() {
      this.$store.dispatch(
        "user/setSnack",
        "Something went wrong while upload Image"
      );
      this.$store.dispatch("user/setType", "error");
    },
    uploadedImage() {
      if (this.media && this.media.length > 0) {
        this.media.filter((media) => {
          if (media.mediaType == "image") {
            var file = {
              size: media.size,
              name: media.name,
              type: media.type,
            };
            this.$refs.myVueDropzone.manuallyAddFile(file, media.url);
          }
        });
      }
    },
    removeFile(file) {
      if (file.size > 1024 * 1024 * 2) {
        this.$store.dispatch(
          "user/setSnack",
          "Upto 2MB File size is allowed"
        );
        this.$store.dispatch("user/setType", "error");
      }
      this.deletePicture(file);
    },
    async deletePicture(file) {
      try {
        if (file) {
          let mediaId = this.media.filter((media) => {
            if (media.mediaType == "image" && media.name == file.name) {
              return media._id;
            }
          });
          if (mediaId.length > 0) {
            const response = await MediaService.deleteMedia({
              id: mediaId[0]._id,
              body: {
                moduleType: "education/journalClub",
                moduleId: this.journalClubId,
              },
            });
            this.getJournalClubData();
            if (response) {
              this.$store.dispatch(
                "user/setSnack",
                "Journal Club image deleted successfully!"
              );
              this.$store.dispatch("user/setType", "info");
            }
          }
        }
      } catch (error) {
        this.$store.dispatch("user/setSnack", error);
        this.$store.dispatch("user/setType", "error");
      }
    },
    cancel() {
      this.$router.push("/journal-club");
    },
    // uploadedBannerImage() {
    //   this.$set(this.bannerImageOption,'croppedUrl',null)
    //   if (this.media && this.media.length > 0) {
    //     this.media.filter((media) => {
    //       if (media.mediaType == "image" && media.imageType === MEDIATYPE_BANNER) {
    //         var file = {
    //           size: media.size,
    //           name: media.name,
    //           type: media.type,
    //           imageType: media.imageType
    //         };
    //         this.bannerImageOption.croppedFile = file;
    //         let imageUrl = (media.bannerUrl) ? media.bannerUrl : media.url;
    //         this.$set(this.bannerImageOption,'croppedUrl',imageUrl)
    //       }
    //     });
    //   }
    // },
  },
};
</script>

<style scoped>
.main-content .navbar-top {
  display: none !important;
}
.banner-img{
  width: 300px !important;
  height: 200px !important;
}
.upload-img-section{
    border: 3px solid #D6E0EF !important;
    border-style: dashed !important;
    border-radius: 6px !important;
}
</style>